<script>
import IMask from 'imask';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentMask: '+000000000000000',
    el: null,
    elFocus: false,
  }),
  computed: {
    country() {
      if (this.value.indexOf('77') === 0) {
        return 'kz';
      }
      if (this.value.indexOf('7') === 0) {
        return 'ru';
      }
      if (this.value.indexOf('380') === 0) {
        return 'ua';
      }
      if (this.value.indexOf('375') === 0) {
        return 'by';
      }
      return '';
    },
  },
  watch: {
    value(v) {
      this.el.unmaskedValue = v;
      this.updateMask();
    },
  },
  methods: {
    updateMask() {
      const val = this.el.unmaskedValue;
      let mask = '+000000000000000000000';
      if (val.indexOf('7') === 0) {
        mask = '+0 (000) 000-00-00';
      }
      if (val.indexOf('380') === 0) {
        mask = '+000 (00) 000-00-00';
      }
      if (val.indexOf('375') === 0) {
        mask = '+000 (00) 000-00-00';
      }
      if (val.indexOf('3800') === 0) {
        mask = '+000 (000) 000-00-00';
      }
      if (mask !== this.currentMask) {
        this.currentMask = mask;
        this.el.updateOptions({
          mask: this.currentMask,
        });
      }
    },
    blur() {
      this.$emit('blur');
      if (this.el.unmaskedValue === '') {
        this.el.value = '';
      }
      if (this.elFocus) {
        const val = this.el.unmaskedValue;
        this.$emit('input', val);
        this.$emit('change', val);
      }
      this.elFocus = false;
    },
    focus() {
      this.elFocus = true;
      this.$emit('focus');
    },
    submit() {
      this.$refs.input.blur();
      this.$emit('submit');
    },
  },
  mounted() {
    const refs = this.$refs;
    this.el = IMask(refs.input, {
      mask: this.currentMask,
    });
    this.el.on('accept', () => {
      if (!this.elFocus) {
        return;
      }
      const val = this.el.unmaskedValue;
      this.$emit('input', val);
      this.updateMask();
    });
    this.el.unmaskedValue = this.value;
    this.updateMask();
  },
};
</script>
<template>
  <div class="f-flex">
    <input
      ref="input"
      type="text"
      class="f-c-input f-flex__auto"
      :disabled="disabled"
      @blur="blur"
      @focus="focus"
      @keypress.enter="submit"
    >
    <IconFlag
      class="f-flex__shink"
      style="margin: 0 4px"
      :country="country"
    />
  </div>
</template>
